module.exports = __webpack_public_path__ + "static/media/18.e51bc317.png";